/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Orders_Carrier_Payment_Link_FailedInputs */

const en_orders_carrier_payment_link_failed = /** @type {(inputs: Orders_Carrier_Payment_Link_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carrier updated, but payment link generation failed: ${i?.message}`)
};

const es_orders_carrier_payment_link_failed = /** @type {(inputs: Orders_Carrier_Payment_Link_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se actualizo el transportista, pero fallo la generacion del link de pago: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Carrier updated, but payment link generation failed: {message}" |
*
* @param {Orders_Carrier_Payment_Link_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_payment_link_failed = /** @type {((inputs: Orders_Carrier_Payment_Link_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Payment_Link_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_payment_link_failed(inputs)
	return es_orders_carrier_payment_link_failed(inputs)
});